import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { WorkspaceService } from '../../workspace.service';

@Component({
  selector: 'app-machine-list',
  templateUrl: './machine-list.component.html',
  styleUrls: ['./machine-list.component.css']
})
export class MachineListComponent implements OnInit {
  @Input() activeOrderList: any;
  @Input() userEmail: any;
  @Input() userPwd: any;

  forSearchOrFilter: any; // for searching user
  currentPage: number = 1;
  showSpinner: boolean = false;
  showFirstPage: boolean = false;
  showSecondPage: boolean = false;
  showMorePopUp: boolean = false;
  selectedUrl: string = '';
  popupTitle: string = '';
  userList: any[] = [];
  id: string = Math.round(Math.random() * 1000).toString();

  url1: string = '';
  iframe_id_1: string = '';
  title1: string = '';
  url2: string = '';
  iframe_id_2: string = '';
  title2: string = '';
  url3: string = '';
  iframe_id_3: string = '';
  title3: string = '';
  url4: string = '';
  iframe_id_4: string = '';
  title4: string = '';
  url5: string = '';
  iframe_id_5: string = '';
  title5: string = '';
  url6: string = '';
  iframe_id_6: string = '';
  title6: string = '';
  url7: string = '';
  iframe_id_7: string = '';
  title7: string = '';
  url8: string = '';
  iframe_id_8: string = '';
  title8: string = '';
  url9: string = '';
  iframe_id_9: string = '';
  title9: string = '';
  url10: string = '';
  iframe_id_10: string = '';
  title10: string = '';
  userFromLocalstorage: any;

  constructor(public dataService: WorkspaceService, myElement: ElementRef) {
    this.showFirstPage = true;
    this.showSecondPage = false;

    if (localStorage.getItem('userList')) {
      let item = JSON.parse(localStorage.getItem('userList'));
      this.userFromLocalstorage = item;
    }
  }

  ngOnInit() {
    let users = [];

    this.activeOrderList.forEach((x) => {
      let user = { name: '', id: '' };
      let name: any;
      debugger;
      name = this.filterLocalStorage(x.id);
      if (name) { user.name = name; }
      else { user.name = x.cfg; }
      user.id = x.id;
      users.push(user);
    });

    this.userList = users;
    this.forSearchOrFilter = this.userList; // for searching user

    this.activeOrderList.forEach((element, i) => {
      this.showSpinner = true;
      let connectVMData = { mail: '', passw: '', order_id: '' };
      connectVMData.mail = this.userEmail;
      connectVMData.passw = this.userPwd;
      connectVMData.order_id = element.id;
      this.dataService.connectVM(connectVMData)
        .subscribe(data => {

          let receivedData = data as any;
          if (i == 0) {
            let name = this.filterLocalStorage(element.id);
            if (name) { this.title1 = name; }
            else { this.title1 = element.cfg; }
            this.url1 = receivedData.url;
            this.iframe_id_1 = element.id;
          }
          else if (i == 1) {
            this.url2 = receivedData.url;
            this.iframe_id_2 = element.id;
            // if (!element.goal) {
            //   this.title2 = element.cfg + '_' + i;
            // }
            // else {
            //   this.title2 = element.goal;
            // }
            let name = this.filterLocalStorage(element.id);
            if (name) { this.title2 = name; }
            else { this.title2 = element.cfg; }
          }
          else if (i == 2) {
            this.url3 = receivedData.url;
            this.iframe_id_3 = element.id;
            // if (!element.goal) {
            //   this.title3 = element.cfg + '_' + i;
            // }
            // else {
            //   this.title3 = element.goal;
            // }
            let name = this.filterLocalStorage(element.id);
            if (name) { this.title3 = name; }
            else { this.title3 = element.cfg; }
          }
          else if (i == 3) {
            this.iframe_id_4 = element.id;
            this.url4 = receivedData.url;
            // if (!element.goal) {
            //   this.title4 = element.cfg + '_' + i;
            // }
            // else {
            //   this.title4 = element.goal;
            // }
            let name = this.filterLocalStorage(element.id);
            if (name) { this.title4 = name; }
            else { this.title4 = element.cfg; }
          }
          else if (i == 4) {
            this.url5 = receivedData.url;
            this.iframe_id_5 = element.id;
            // if (!element.goal) {
            //   this.title5 = element.cfg + '_' + i;
            // }
            // else {
            //   this.title5 = element.goal;
            // }
            let name = this.filterLocalStorage(element.id);
            if (name) { this.title5 = name; }
            else { this.title5 = element.cfg; }
          }
          else if (i == 5) {
            this.url6 = receivedData.url;
            this.iframe_id_6 = element.id;
            let name = this.filterLocalStorage(element.id);
            if (name) { this.title6 = name; }
            else { this.title6 = element.cfg; }
            // if (!element.goal) {
            //   this.title6 = element.cfg + '_' + i;
            // }
            // else {
            //   this.title6 = element.goal;
            // }
          }
          else if (i == 6) {
            this.url7 = receivedData.url;
            this.iframe_id_7 = element.id;
            // if (!element.goal) {
            //   this.title7 = element.cfg + '_' + i;
            // }
            // else {
            //   this.title7 = element.goal;
            // }
            let name = this.filterLocalStorage(element.id);
            if (name) { this.title7 = name; }
            else { this.title7 = element.cfg; }
          }
          else if (i == 7) {
            this.url8 = receivedData.url;
            this.iframe_id_8 = element.id;
            // if (!element.goal) {
            //   this.title8 = element.cfg + '_' + i;
            // }
            // else {
            //   this.title8 = element.goal;
            // }
            let name = this.filterLocalStorage(element.id);
            if (name) { this.title8 = name; }
            else { this.title8 = element.cfg; }
          }
          else if (i == 8) {
            this.url9 = receivedData.url;
            this.iframe_id_9 = element.id;
            // if (!element.goal) {
            //   this.title9 = element.cfg + '_' + i;
            // }
            // else {
            //   this.title9 = element.goal;
            // }
            let name = this.filterLocalStorage(element.id);
            if (name) { this.title9 = name; }
            else { this.title9 = element.cfg; }
          }
          else if (i == 9) {
            this.url10 = receivedData.url;
            this.iframe_id_10 = element.id;
            // if (!element.goal) {
            //   this.title10 = element.cfg + '_' + i;
            // }
            // else {
            //   this.title10 = element.goal;
            // }
            let name = this.filterLocalStorage(element.id);
            if (name) { this.title10 = name; }
            else { this.title10 = element.cfg; }
          }

          this.showSpinner = false;
        },
          error => {
            this.showSpinner = false;
            console.log('error occured when calling /token');
          })
    });
  }
  highlightIframe(id: string) {
    let iframes = document.querySelectorAll('iframe');
    if (iframes.length > 0) {
      Array.from(iframes).forEach(element => {
        element.style.borderColor = "white";
      });
    }
    let selectedIframe = document.getElementById(id) as any;
    selectedIframe.style.borderColor = "orange";
  }
  seeMoreDetails(url: string, title: string) {
    this.selectedUrl = url;
    this.popupTitle = title.toUpperCase();
    this.showMorePopUp = true;
  }
  closePopUp() {
    this.selectedUrl = '';
    this.popupTitle = '';
    this.showMorePopUp = false;
  }
  clean() {
    this.userList = this.forSearchOrFilter;
  }
  searchTable(name: string) {
    if (!name) {
      this.userList = this.forSearchOrFilter;
    } else {
      this.userList = this.forSearchOrFilter.filter(x =>
        x.name.trim().toLowerCase().includes(name.trim().toLowerCase())
      );
    }
  }
  showAllUsers() {
    this.showFirstPage = true;
    this.showSecondPage = false;
    let iframes = document.querySelectorAll('iframe');
    if (iframes.length > 0) {
      Array.from(iframes).forEach(element => {
        element.style.borderColor = "white";
      });
    }
    this.userList = this.forSearchOrFilter;
    this.currentPage = 1;
  }
  clickedPageChange(page: any) {
    if (page.currentPage == 1) {
      this.showFirstPage = true;
      this.showSecondPage = false;
    }
    else {
      this.showFirstPage = false;
      this.showSecondPage = true;
    }
  }
  clickedPrevious() {
    this.showFirstPage = true;
    this.showSecondPage = false;
  }
  clickedNext() {
    this.showFirstPage = false;
    this.showSecondPage = true;
  }
  filterLocalStorage(orderId: any) {
    let item: any = null;
    let name: any = null;
    if (this.userFromLocalstorage) {
      if (Array.isArray(this.userFromLocalstorage)) {
        item = this.userFromLocalstorage.filter(function (x) { return x.id === orderId });
        name = item[item.length - 1].value; // take latest incase of multiple/duplicate
      }
      else {
        item = this.userFromLocalstorage;
        name = item.value;
      }
      return name;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/create-workspace/machine-list/machine-list.component.ts